import React from 'react';
import { FlatCard } from 'apps/sigma2-ui/src/components/ui/FlatCard';

interface NoResultsWideCardProps {
  icon: React.ReactNode;
  rightHandSideContent: React.ReactNode;
  leftHandSideContent: React.ReactNode;
}

export const NoResultsWideCard = ({
  icon,
  rightHandSideContent,
  leftHandSideContent,
}: NoResultsWideCardProps) => {
  return (
    <FlatCard
      className="flex bg-white divide-x divide-gray-150"
      paddingClassName="p-0"
    >
      <div className="basis-2/3 py-16 px-24 content-center">
        <div className="flex gap-x-7 justify-center ">
          <div className="text-teal-400">{icon}</div>
          <div className="flex">
            <div className="flex flex-col">{leftHandSideContent}</div>
          </div>
        </div>
      </div>
      <div className="basis-1/3 p-16 content-center">
        <div className="flex flex-col justify-center">
          {rightHandSideContent}
        </div>
      </div>
    </FlatCard>
  );
};
